import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import {
    useClientSettingStore,
    useStore,
    useStoreUI
} from '@assets/model/Store';
import { useNavUtils } from '@assets/utils/NavUtils';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import { DraggableSplit } from '../DraggableSplit/DraggableSplit';
import { PanelBusinessOverview } from '../Financial/PanelBusinessOverview/PanelBusinessOverview';
import { PanelCompanyFinancials } from '../Financial/PanelCompanyYearly/PanelCompanyFinancials';
import { PanelIndustry } from '../Financial/PanelIndustry/PanelIndustry';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import { PDFViewerPanel } from '../PDFViewerPanel/PDFViewerPanel';
import { Flex } from '../UI/Flex/Flex';
import { PanelCustomers } from '../Financial/PanelCompanyYearly/SubPanels/Customers/PanelCustomers';
import { PanelAcquisitions } from '../Financial/PanelCompanyYearly/SubPanels/Acquisitions/PanelAcquisitions';

export const DealDetails = observer(() => {
    const store = useStore();
    const q = store.query;
    const nav = useNavUtils();
    const showBeta = useClientSettingStore().showBetaFeatures;

    useEffect(
        function auditReportView() {
            getFirebase().store_audit_entry('VIEW_PAGE_DEAL', {
                page: 'DealView',
                deal_id: store.selectedReportId,
                url: window.location.href
            });
        },
        [store.selectedReportId]
    );

    if (!store.query) {
        return null;
    }
    const pdfUrl = store.query.value('pdf');
    const companyName = store.query.value('company_name');

    return (
        <DraggableSplit spaceBetween={12}>
            <ScrollPanel enableHideScrollUntilMouseOver={true}>
                <Flex
                    direction="column"
                    style={{ gap: '20px', position: 'relative' }}
                >
                    <PanelCompanyFinancials />
                    {showBeta && (
                        <>
                            <PanelCustomers />
                            <PanelAcquisitions />
                        </>
                    )}
                    <PanelIndustry />
                    <PanelBusinessOverview />
                </Flex>
            </ScrollPanel>

            <PDFViewerPanel
                pdfUrl={q.pdfViewUrl}
                title_display={q.companyName}
            />
        </DraggableSplit>
    );
});
